import React, { createContext, useContext, useMemo } from "react";
import { ACCESS_TIERS } from "constants";

const AccessTierContext = createContext();

export function AccessTierProvider({ accessTier, children }) {
  const value = useMemo(
    () => ({
      accessTier,
      isAPlus: accessTier === ACCESS_TIERS.A_PLUS,
      isAPlusTeacher: accessTier === ACCESS_TIERS.A_PLUS_TEACHER,
      isFree: accessTier === ACCESS_TIERS.FREE,
      isSignedOut: accessTier === ACCESS_TIERS.SIGNED_OUT
    }),
    [accessTier]
  );

  return (
    <AccessTierContext.Provider value={value}>
      {children}
    </AccessTierContext.Provider>
  );
}

export function useAccessTier() {
  const context = useContext(AccessTierContext);
  if (!context) {
    throw new Error("useAccessTier must be used within an AccessTierProvider");
  }
  return context;
}
